import React, { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Loading from "components/shared-components/Loading";
import { APP_PREFIX_PATH } from "configs/AppConfig";

export const AppViews = () => {

  return (
    <Suspense fallback={<Loading cover="page" />}>
      <Routes>
        <Route
          path={`${APP_PREFIX_PATH}/login`}
          Component={lazy(() => import(`./authentication/login`))}
          exact
        />
        <Route
          path={`${APP_PREFIX_PATH}/register`}
          Component={lazy(() => import(`./authentication/register`))}
          exact
        />
        <Route
          path={`${APP_PREFIX_PATH}/forgot-password`}
          Component={lazy(() => import(`./authentication/forgot-password`))}
          exact
        />
        <Route
          path={`${APP_PREFIX_PATH}/forgot-password-otp`}
          Component={lazy(() => import(`./authentication/otp`))}
          exact
        />
        <Route
          path={`${APP_PREFIX_PATH}/reset-password`}
          Component={lazy(() => import(`./authentication/reset-password`))}
          exact
        />
        <Route
            path={`/privacy`}
            Component={lazy(() => import(`./authentication/pages`))}
            exact
        />
        <Route
            path={`/terms-and-conditions`}
            Component={lazy(() => import(`./authentication/pages`))}
            exact
        />
        <Route
            path={`/about`}
            Component={lazy(() => import(`./authentication/pages`))}
            exact
        />
        <Route
            path={`/refunds-and-cancellation-fleet`}
            Component={lazy(() => import(`./authentication/pages`))}
            exact
        />
        <Route
            path={`/payment`}
            Component={lazy(() => import(`./authentication/pages`))}
            exact
        />
        <Route
            path={`/refunds-and-cancellation-customer`}
            Component={lazy(() => import(`./authentication/pages`))}
            exact
        />
        <Route
            path={`/trip`}
            Component={lazy(() => import(`./authentication/pages`))}
            exact
        />
        <Route
          path={`${APP_PREFIX_PATH}/error-1`}
          Component={lazy(() => import(`./errors/error-page-1`))}
          exact
        />
        <Route
          path={`${APP_PREFIX_PATH}/error-2`}
          Component={lazy(() => import(`./errors/error-page-2`))}
          exact
        />
      </Routes>
    </Suspense>
  );
};

export default AppViews;
